import React from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../../../assets/icons/red-warning.svg";
import "./DeleteAudioModal.less";
import Loader from "../../../loader/Loader";

export type DeleteAudioModalProps = {
  isOpen: boolean;
  onConfirm?: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

const DeleteAudioModal: React.FC<DeleteAudioModalProps> = ({ isOpen, onConfirm, onCancel, isLoading = false }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (!isLoading) {
      onCancel?.();
    }
  };
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      console.log("[DeleteAudioModal] Simulate API: delete audio");
      onCancel?.();
    }
  };

  return (
    <div className="confirm-delete-category-overlay" onClick={handleOverlayClick}>
      <div className="confirm-delete-category-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line" />
        </div>
        <div className="confirm-delete-category-container">
          <img src={RedWarningIcon} className="confirm-delete-category-icon" alt="Warning" />
          <div className="confirm-delete-category-title">{t("delete-audio-confirm-title")}</div>
          <div className="confirm-delete-category-desc">{t("delete-audio-confirm-desc")}</div>
          <button type="button" className="confirm-delete-button" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? <Loader /> : t("confirm")}
          </button>
          <button type="button" className="confirm-cancel-button" onClick={() => !isLoading && onCancel()} disabled={isLoading}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAudioModal;
